import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TCompetitor } from '@shared/interfaces/TProject';
import { ConfirmationDialogComponent, ConfirmDialogData } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { TBaseSettingsTabParams } from '../project-settings.component';

@Component({
  selector: 'app-competitors-settings',
  templateUrl: './competitors.component.html',
  styleUrls: ['./competitors.component.scss'],
})
export class CompetitorsComponent {
  public params: TBaseSettingsTabParams;
  public competitors: TCompetitor[] = [];
  public newCompetitor: TCompetitor = { id: crypto.randomUUID(), name: '', description: '' };

  constructor(
    public dialogRef: MatDialogRef<CompetitorsComponent>,
    public dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data: TBaseSettingsTabParams
  ) {
    this.params = data;
    this.competitors = this.loadCompetitors();
  }

  loadCompetitors(): TCompetitor[] {
    return this.params.selectedProject?.competitors
    ? [...this.params.selectedProject.competitors]
    : [];
  }

  addCompetitor(): void {
    if (!this.newCompetitor.name.trim()) return;
    if (this.params.selectedProject) {
      if (!this.params.selectedProject.competitors) {
        this.params.selectedProject.competitors = [];
      }
      if (!this.competitors.filter((competitor: TCompetitor) => competitor.name.toLowerCase().trim() === this.newCompetitor.name.toLowerCase().trim() ).length) {
        this.params.selectedProject.competitors.push({ ...this.newCompetitor });
        this.competitors = this.loadCompetitors();
        this.newCompetitor = { id: crypto.randomUUID(), name: '', description: '' };
      }
    }
  }

  updateCompetitorName(index: number, name: string): void {
    if (this.params.selectedProject) {
      if (this.params.selectedProject.competitors) {
        this.params.selectedProject.competitors[index]['name'] = name;
        this.competitors = this.loadCompetitors();
      }
    }
  }

  updateCompetitorDescription(index: number, description: string): void {
    if (this.params.selectedProject) {
      if (this.params.selectedProject.competitors) {
        this.params.selectedProject.competitors[index]['description'] = description;
        this.competitors = this.loadCompetitors();
      }
    }
  }

  deleteCompetitor(index: number): void {
    const competitor = this.competitors[index];
    if (!competitor) return;

    const dialogData: ConfirmDialogData = {
      title: 'Are you sure?',
      message: 'Deleting a competitor will remove all associated sales data. This action cannot be undone.',
      confirmButton: 'Delete',
      dismissButton: 'Cancel',
    };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: dialogData, width: '600px' });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        if (this.params.selectedProject) {
          if (this.params.selectedProject.competitors) {
            this.params.selectedProject.competitors = this.params.selectedProject.competitors.filter((c: TCompetitor) => c.id !== competitor.id);
            this.competitors = this.loadCompetitors();
            this.deleteCompetitorSales(competitor.id);
          }
        }
      }
    });
  }

  deleteCompetitorSales(competitorId: string): void {
    if (this.params.selectedProject && this.params.selectedProject.accountBricks) {
      this.params.selectedProject.accountBricks.forEach((brick) => {
        brick.salesCompetitors = brick.salesCompetitors?.filter((sale) => sale.competitorId !== competitorId);
      });
    }
  }

}
